import { type ComponentProps } from 'react'

import { TimeInputSection } from '@/modules/expiring-fans/components/time-input-section.tsx'
import { useDebouncedProperty } from '@/utils/useDebouncedProperty.ts'

interface Props {
  minHoursSinceLastMessage: number
  changeMinHoursSinceLastMessage: (value: number) => void
  disabled?: boolean
}

export const TimeLimitationController = ({
  minHoursSinceLastMessage,
  changeMinHoursSinceLastMessage,
  disabled,
  ...props
}: ComponentProps<'div'> & Props) => {
  const [currentMinHoursSinceLastMessage, setMinHoursSinceLastMessage] =
    useDebouncedProperty<number | undefined>(
      minHoursSinceLastMessage,
      (value) => changeMinHoursSinceLastMessage(value ?? 0),
    )

  return (
    <TimeInputSection
      {...props}
      title="Time Limitation"
      description="Only send messages if the last chat is older than the specified amount of time"
      value={currentMinHoursSinceLastMessage}
      onChange={setMinHoursSinceLastMessage}
      textClassName="max-w-[8rem]"
      disabled={disabled}
    />
  )
}
